import {isString} from 'lodash';

/* eslint global-require: 0 */
const importedAudios = {
  chatNotification: require('../assets/audio/chatNotification.m4a'),
};

/*
 * Types.
 */

export type AudioName = keyof typeof importedAudios;

/*
 * Helpers.
 */

export function isAudioName(s: any): s is AudioName {
  return isString(s) && s in importedAudios;
}

function createAudio(audioName: AudioName) {
  if (!isAudioName(audioName)) {
    throw new Error(`There is no audio set up for ${audioName}.`);
  }

  return new Audio(importedAudios[audioName]);
}

export const playAudio = (audioName: AudioName) => {
  const audio = createAudio(audioName);
  audio.oncanplaythrough = () => audio.play();
};
